import React from 'react';
import PhoneInput from 'react-phone-input-2';

import 'react-phone-input-2/lib/style.css';

const locale = navigator.language;
let defaultCountry = '';

const BobContactPhoneInput = (
    {
        width,
        hasError,
        defaultCode,
        ...props
    }
) => {
    defaultCountry = locale && locale.includes('en_AU') ? 'au' : 'us';

    const styles = {
        width:         '100%',
        outline:       'none',
        border:        'none',
        borderBottom:  '1px solid #c6c6c6',
        borderRight:   '1px solid #c6c6c6',
        borderTop:     '1px solid #c6c6c6',
        borderRadius:  3,
        paddingTop:    15,
        paddingLeft:   42,
        paddingBottom: '12px',
        fontSize:      '12px'
    };

    const errorStyles = {
        width:         '100%',
        outline:       'none',
        border:        'none',
        borderBottom:  '1px solid red',
        borderRight:   '1px solid red',
        borderTop:     '1px solid red',
        borderRadius:  3,
        paddingTop:    15,
        paddingLeft:   42,
        paddingBottom: '12px',
        fontSize:      '12px'
    };

    const buttonStyles = {
        height:          '35px',
        border:          'none',
        backgroundColor: '#fff',
        borderBottom:    '1px solid #c6c6c6',
        borderLeft:      '1px solid #c6c6c6',
        borderTop:       '1px solid #c6c6c6',
        borderRadius:    3,
        paddingBottom:   '12px',
        paddingTop:      11
    };

    const buttonErrorStyles = {
        height:          '35px',
        border:          'none',
        backgroundColor: '#fff',
        borderBottom:    '1px solid red',
        borderLeft:      '1px solid red',
        borderTop:       '1px solid red',
        borderRadius:    3,
        paddingBottom:   '12px',
        paddingTop:      11
    };

    const dropDownStyles = {
        position: 'fixed'
    };

    return (
        <React.Fragment>
            <PhoneInput
                inputStyle={hasError ? errorStyles : styles}
                buttonStyle={hasError ? buttonErrorStyles : buttonStyles}
                dropdownStyle={dropDownStyles}
                country={defaultCode ? defaultCode : defaultCountry}
                countryCodeEditable={false}
                copyNumbersOnly={true}
                {...props}
            />
        </React.Fragment>
    );
};

export default BobContactPhoneInput;
